export default __webpack_public_path__ + "static/media/Earn.2e5d1c34.png";